import React, { createContext, useState } from 'react';
import { v4 as uuid } from 'uuid';

export const defaultAlertState = {
  alerts: [],
};

const handleRemoveAlert = setAlertState => id =>
  setAlertState(state => ({
    alerts: state.alerts.filter(al => al.id !== id),
  }));
const handleAddAlert = setAlertState => alert =>
  setAlertState(state => ({
    alerts: [...state.alerts, { ...alert, id: uuid() }],
  }));

export const AlertContext = createContext();

const AlertContextProvider = ({ children }) => {
  const [alertState, setAlertState] = useState({
    ...defaultAlertState,
  });

  const alertContextValue = {
    ...alertState,
    addAlert: handleAddAlert(setAlertState),
    removeAlert: handleRemoveAlert(setAlertState),
  };
  return (
    <AlertContext.Provider value={alertContextValue}>
      {children}
    </AlertContext.Provider>
  );
};

export default AlertContextProvider;
